export enum REPORT_TYPE {
  USER = "user",
  STREAM_FEED = "stream_feed",
  STREAM_FEED_COMMENT = "stream_feed_commnet",
  NFT_FEED = "nft_feed",
  NFT_FEED_COMMENT = "nft_feed_comment",
  OTHER = "other",
}
